<template>
  <ul class="f-a-tabs">
    <li
      v-for="(item, index) in items" :key="`${item}_${index}`"
      :class="{active: getValue(item) === tab}"
      @click="tab = getValue(item)"
    >
      <div class="flex justify-center" style="height: 5px;">
        <svg v-if="getValue(item) === tab" width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.5 0L4.5 5L8.5 0H0.5Z" fill="#7E72F2"/>
        </svg>
      </div>
      <div>{{getLabel(item)}}</div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "FATabs",
  props: {
    value: [Number, String],
    items: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    tab: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    getLabel(item) {
      if (typeof item === 'object' && item !== null) {
        return item.label || '';
      }
      return item;
    },
    getValue(item) {
      if (typeof item === 'object' && item !== null) {
        return item.value || '';
      }
      return item;
    }
  }
}
</script>

<style scoped lang="scss">
.f-a-tabs {
  border-bottom: 1px solid #E6E9F4;
  display: flex;
  li {
    cursor: pointer;
    padding: 8px
  }
  li.active {
    color: #7E72F2;
  }
}
</style>
